// Shared predefined test sub-categories for path lab workflow
export const PREDEFINED_TEST_CATEGORIES = {
  "CBC": [
    { name: "Hemoglobin", referenceValue: "M-14-18gm%, F-12-16gm%", unit: "Gm/dl" },
    { name: "TLC", referenceValue: "4000-11,000", unit: "/cumm" },
    { name: "DLC", referenceValue: "", unit: "" },
    { name: "Neutrophils", referenceValue: "40-75", unit: "%" },
    { name: "Lymphocytes", referenceValue: "20-45", unit: "%" },
    { name: "Monocytes", referenceValue: "02-10", unit: "%" },
    { name: "Eosinophils", referenceValue: "01-06", unit: "%" },
    { name: "Basophils", referenceValue: "00-1", unit: "%" },
    { name: "ESR (wintrobes)", referenceValue: "<20", unit:"mm/hrs"},
    { name: "Platelet Count", referenceValue: "1.5-4.0", unit: "lacs/cumm" },
    { name: "Blood Group", referenceValue: "", unit: "" }
  ],
  "Widal": [
    { name: "S. Typhi (O)", referenceValue: "<1:80", unit: "" },
    { name: "S. Typhi (H)", referenceValue: "<1:80", unit: "" }
  ],
  "Typhoid": [
    { name: "IgG", referenceValue: "Negative", unit: "" },
    { name: "IgM", referenceValue: "Negative", unit: "" }
  ],
  "Serology": [
    { name: "RA Factor", referenceValue: "Negative", unit: "" },
    { name: "CRP", referenceValue: "Negative", unit: "" },
    { name: "VDRL", referenceValue: "Negative", unit: "" },
    { name: "HCV", referenceValue: "Negative", unit: "" },
    { name: "HBsAg", referenceValue: "Negative", unit: "" },
    { name: "HIV I by Card", referenceValue: "Negative", unit: "" },
    { name: "HIV II by Card", referenceValue: "Negative", unit: "" }
  ],
  "Thyroid Profile": [
    { name: "T3", referenceValue: "0.8-2.0", unit: "ng/ml" },
    { name: "T4", referenceValue: "57.9-150.6", unit: "nmol/ltr" },
    { name: "TSH", referenceValue: "0.4-4.0", unit: "mIU/ml" }
  ],
  "GLUCOSE PROFILE": [
    { name: "Blood Glucose (Fasting)", referenceValue: "70-100", unit: "mg/dl" },
    { name: "Blood Glucose (PP)", referenceValue: "<140", unit: "mg/dl" },
    { name: "Blood Glucose (Random)", referenceValue: "<160", unit: "mg/dl" },
    { name: "HbA1C", referenceValue: "<6.5", unit: "%" }
  ],
  "KFT": [
    { name: "Blood Urea", referenceValue: "15-45", unit: "mg/dl" },
    { name: "Blood Creatinine", referenceValue: "0.6-1.2", unit: "mg/dl" },
    { name: "Uric Acid", referenceValue: "3.5-7.0", unit: "mg/dl" }
  ],
  "LFT": [
    { name: "S.Bilirubin (T)", referenceValue: "0.3-1.0", unit: "mg/dl" },
    { name: "S.Bilirubin (D)", referenceValue: "0.1-0.3", unit: "mg/dl" },
    { name: "SGOT/AST", referenceValue: "7-42", unit: "IU/L" },
    { name: "SGOT/ALT", referenceValue: "7-42", unit: "IU/L" },
    { name: "ALP", referenceValue: "98-279", unit: "IU/L" }
  ],
  "LIPID PROFILE": [
    { name: "Cholesterol", referenceValue: "<200", unit: "mg/dl" },
    { name: "Triglycerides", referenceValue: "<150", unit: "mg/dl" },
    { name: "HDL", referenceValue: ">35", unit: "mg/dl" },
    { name: "VL.DL", referenceValue: "5-20", unit: "mg/dl" },
    { name: "LDL", referenceValue: "<140", unit: "mg/dl" }
  ],
  "Urine Test": [
    { name: "Colour", referenceValue: "Pale Yellow", unit: "", category: "Routine" },
    { name: "Sp. Gr", referenceValue: "1.003-1.030", unit: "", category: "Routine" },
    { name: "Transparency", referenceValue: "Clear", unit: "", category: "Routine" },
    { name: "Reaction", referenceValue: "5.0-8.0", unit: "pH", category: "Routine" },
    { name: "Albumin", referenceValue: "", unit: "", category: "Chemical" },
    { name: "Sugar", referenceValue: "", unit: "", category: "Chemical" },
    { name: "Bile Salt", referenceValue: "Negative", unit: "", category: "Chemical" },
    { name: "Bile Pigment", referenceValue: "Negative", unit: "", category: "Chemical" },
    { name: "Urobilinogen", referenceValue: "Normal", unit: "", category: "Chemical" },
    { name: "RBC", referenceValue: "0-2", unit: "/hpf", category: "Microscopic" },
    { name: "Pus Cell", referenceValue: "0-3", unit: "/hpf", category: "Microscopic" },
    { name: "Epithelial Cell", referenceValue: "Few", unit: "/hpf", category: "Microscopic" },
    { name: "Casts", referenceValue: "None", unit: "/hpf", category: "Microscopic" },
    { name: "Crystal", referenceValue: "None", unit: "/hpf", category: "Microscopic" }
  ],
  "Semen Analysis": [
    { name: "Semen", referenceValue: "", unit: "ml" },
    { name: "Viscosity", referenceValue: "Normal", unit: "" },
    { name: "Total count", referenceValue: "40", unit: "million" },
    { name: "Morphology", referenceValue: "Normal", unit: "" },
    { name: "Active Motile", referenceValue: "50", unit: "%" },
    { name: "Sluggish Motile", referenceValue: "", unit: "" },
    { name: "Non Motile", referenceValue: "", unit: "" },
    { name: "Quantity", referenceValue: "2", unit: "ml" }
  ]
};

export const PREDEFINED_TEST_NAMES = Object.keys(PREDEFINED_TEST_CATEGORIES);
